// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumbs_container__Xzi06","item":"Breadcrumbs_item__D3Ih0","link":"Breadcrumbs_link__udqxZ","current":"Breadcrumbs_current__tOKWM","sep":"Breadcrumbs_sep__cByvy"};